'use strict';

angular.module('buyers')
.filter('tasksPending', ['$log', function($log) {

  // Show archived vs. pending tasks
  return function(tasks, toggle) {
    var output =[];

    if(tasks.length > 0) {
      angular.forEach(tasks, function(task) {
          if(task.active && toggle == 'new') {
              output.push(task);
          } else if (!task.active && toggle !== 'new') {
              output.push(task);
          }
      });
    }
    
    return output;
  }

}]);